import { render, staticRenderFns } from "./messageCenter.vue?vue&type=template&id=7a2ae7f1&scoped=true&"
import script from "./messageCenter.vue?vue&type=script&lang=js&"
export * from "./messageCenter.vue?vue&type=script&lang=js&"
import style1 from "./messageCenter.vue?vue&type=style&index=1&id=7a2ae7f1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2ae7f1",
  null
  
)

export default component.exports